import SummaryTitle from './SummaryTitle';

export default SummaryTitle;
